// Upload links are stored in two shapes across the app:
//   { data: 'https://…', fileData: {…} }   (upload API response)
//   'https://…'                            (chat attachments, older posts)
// Return the URL string for either, or '' when there is none.
export const resolveLink = link => {
  if (!link) return ''
  if (typeof link === 'string') return link
  if (typeof link === 'object' && typeof link.data === 'string') return link.data
  return ''
}

// Best URL for a document post, whatever page it came from
export const documentUrl = item =>
  item?.document || resolveLink(item?.Data?.DocumentLink)

// Best URL for an image post (Updates / Timeline)
export const imageUrl = item =>
  resolveLink(item?.Data?.ImageLink) || (typeof item?.image === 'string' ? item.image : '')

const VIDEO_EXT = /\.(mp4|m4v|webm|mov|ogv|ogg)(\?|#|$)/i

// Media for a timeline post. Videos share the ImageLink field; they are
// recognised by Data.MediaType, the upload's mimetype, or the URL extension.
export const mediaInfo = item => {
  const url = imageUrl(item)
  const link = item?.Data?.ImageLink
  const mime = link && typeof link === 'object' ? link.fileData?.type || '' : ''
  const isVideo =
    item?.Data?.MediaType === 'video' || mime.startsWith('video/') || VIDEO_EXT.test(url)
  return { url, isVideo }
}
